import React from 'react'
import { WhatsApp } from '@mui/icons-material'
import { supportWhatsAppUrl } from '../../utils/supportWhatsApp'
import { SupportButton } from './styles'

const buildMessage = (valor) =>
  valor
    ? `Hola, no puedo ingresar a Trakku web. Mi número o correo es ${valor}.`
    : 'Hola, no puedo ingresar a Trakku web.'

// Soporte puede ver el último código enviado desde trakku-admin y ayudar a ingresar.
function SupportLink({ valor, onDark }) {
  return (
    <SupportButton
      href={supportWhatsAppUrl(buildMessage(valor))}
      target="_blank"
      rel="noopener noreferrer"
      startIcon={<WhatsApp />}
      onDark={onDark}
    >
      ¿No te llega el código? Escríbenos
    </SupportButton>
  )
}

export { SupportLink }
